import { RouteType } from "types/RouteType";
import { inventoryManagementHubRoutes } from "@intrasync/inventory-management";

/**
 * Routes from `@intrasync/inventory-management`.
 *
 * The package owns its route(s) — same pattern as `@intrasync/designer` and
 * `@intrasync/accounting`. We mount the canonical single-route hub
 * (`inventoryManagementHubRoutes` → name "Inventory", path "/inventory"), under
 * which the 16 features render as tabs. The legacy standalone
 * `inventoryManagementRoutes` (16 top-level routes) is intentionally NOT used.
 */
const inventoryManagementRoutesList: RouteType[] = [
  ...(inventoryManagementHubRoutes as unknown as RouteType[]),
];

export default inventoryManagementRoutesList;
